<template>
    <div class="footer-row pb-3">
        <b-row class="ml-0 mr-0 pt-3">
            <b-col sm="12" lg="8" order="2" order-md="1" class="footer-left">
                <b-row class="ml-0 mr-0 pt-4">
                    <b-col cols="12" md="12" class="logo-wrapper">
                        <b-img
                            fluid
                            src="/images/01_LVI_logo_LV.png"
                            alt="LU Latviesu valodas institūts"
                            class="lavi-logo"
                        ></b-img>
                        <div class="contacts">
                            <p>
                                <span
                                    >Latvijas Universitātes Latviešu valodas
                                    institūts
                                </span>
                                <span>Kalpaka bulvāris 4</span>
                                <span>Rīga, LV-1050 </span>
                            </p>

                            <p>
                                <span>Tālrunis: 67034016 </span>
                                <span>E-pasts: lavi@lu.lv </span>
                            </p>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" order-md="2" order="1" lg="4" class="footer-right">
                <b-img
                    fluid
                    src="/images/VPP_LOGO.png"
                    alt="Valsts Pētījumu programma"
                    class="lavi-logo"
                ></b-img>
                <b-img
                    fluid
                    src="/images/flpp-png.png"
                    alt="Fundamentālo un Lietišķo pētījumu projekti"
                    class="lavi-logo"
                ></b-img>
            </b-col>
        </b-row>
        <div class="copyrights-row">
            <b-link>© 2022 LU LaVI</b-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "appFooter",
};
</script>

<style lang="scss" scoped>
@import "~@/app.scss";

.footer-row {
    width: 100%;
    background: $content-background;
}

.footer-left {
    // justify-content: flex-start;
    // align-items: center;
    // display: flex;

    img {
        padding: 8px;
    }
}

.footer-right {
    // justify-content: flex-end;
    align-items: center;
    // display: flex;
}

.contacts {
    color: $grey-text;
    padding-top: 12px;

    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: $grey400;
}

.contacts span {
    display: block;
}

.copyrights-row {
    text-align: center;

    a {
        color: $red400;
        cursor: pointer;
        text-decoration: underline;

        &:hover {
            color: $black !important;
        }
    }
}

.lavi-logo {
    width: 350px;
}

.logo-wrapper {
    // text-align: center;
}

@media (max-width: $lg-media - 1) {
    .footer-left {
        justify-content: center;
        padding-top: 32px;
    }

    .footer-right {
        justify-content: center;

        .contacts {
            padding-right: 0px;
        }
    }
}

@media (max-width: $sm-media - 1) {
    .footer-left .logo {
        width: 200px;
    }
}

@media (max-width: 450px) {
    .footer-left {
        display: block;
    }
    .footer-left .logo {
        width: 250px;
        display: block;
        margin: 0 auto;
    }
}
</style>
